const AgentInfoDirective = () => ({
    restrict: 'E',
    scope: {},
    templateUrl: 'partials/directives/dt-agent-info.html',
    controller: function (
        $injector,
        $scope,
        agentService
    ) {
        $scope.agentService = agentService;

        try {
            $scope.verifoneDriver = $injector.get('verifoneDriver');
        } catch (e) {
            // Throws an exception if Verifone is not enabled. That's fine. Skip it and move on.
        }

        try {
            $scope.worldpayDriver = $injector.get('worldpayDriverService');
        } catch (e) {
            // Throws an exception if Worldpay is not enabled. That's fine. Skip it and move on.
        }
    },
});

module.exports = AgentInfoDirective;
